/**
 * Shared form functions.
 */
export function shareForm() {
  addAutocomplete();
  shareClaimTrigger();

  /**
   * Adds auto-complete to email container.
   */
  function addAutocomplete() {
    const $emailAutoComplete = $( '.user-share-email' );
    window.mce = 'mce' in window ? window.mce : {};

    $emailAutoComplete.autocomplete({
      source: function( request, response ) {
        $.ajax({
          url: `${window.mce.api_url}users/email`,
          type: 'get',
            data: {
            input: request.term,
          },
          success: function( data ) {
            response( data );
          }
        });
      },
      minLength: 2,
    });
  }

  /**
   * Adds auto-complete to email container.
   */
  function shareClaimTrigger() {
    const $emailAutoComplete = $( '.user-share-email' );
    const $validationError = $( '.modal-share-error' );
    const $validationSuccess = $( '.modal-share-success' );
    const $submitButton = $( '.submit_share_claim' );
    const entryId = $( '.o__ime-form-entry' ).attr( 'data-entry-id' );
    const userId = $( '.o__ime-form-entry' ).attr( 'data-user-id' );

    $submitButton.click( function shareTrigger() {
      if ( !validateEmail( $emailAutoComplete.val() ) || $emailAutoComplete.val() === '' ) {
        $validationSuccess.hide();
        $validationError.show().find( 'span' ).html( 'Please enter a valid email address' );
        return false;
      } else {
        $validationError.hide();
      }

      $.ajax({
        url: `${window.mce.api_url}share/entry`,
        type: 'get',
        data: { 'id': userId, 'entry-id': entryId, 'email': $emailAutoComplete.val() },
        success: function() {
          $validationSuccess.hide();
          $validationSuccess.show()
            .find( 'span' )
            .html( `Your form has been successfully shared with <strong>${$emailAutoComplete.val()}</strong>` );
          $emailAutoComplete.val( '' );
        },
        error: function ( request ) {
          const response = JSON.parse( request.responseText );
          $validationSuccess.hide();
          $validationError.show().find( 'span' ).html( response.message );
        }
      });
    });
  }

  /**
   * Verifies email address format.
   *
   * @param {string} email An email address from input.
   * @returns {bool} Validation result.
   */
  function validateEmail( email ) {
    var emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( email );
  }
}
